import navigation from './components/navigation';
import skipLinks from './components/skip-links';
import tables from './components/tables';
import accordions from './components/accordions';
import dialogs from './components/dialogs';
import tabs from './components/tablist';
import siteSearch from './components/site-search';
import filters from './components/filters';
import responsivePagination from './components/responsive-pagination';
import dialog from './components/dialog';
import pdfViewerStyles from './components/pdf-viewer-styles';

import {createApp} from "vue";
import AlertBars from "./vue/AlertBars.vue";
import IncidentHeroCards from "./vue/IncidentHeroCards.vue";

tabs( document.querySelectorAll( '.tabs' ) );

skipLinks( document.getElementById( 'skip-to-content' ) );

tables( document.querySelectorAll( 'table' ) );

accordions( document.querySelectorAll( 'details' ) );

dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );

siteSearch( document.querySelectorAll( '.site-search' ) );

filters( document.querySelector( '.filters' ) );

pdfViewerStyles( document.querySelectorAll( 'iframe.pdfjs-iframe' ) );

// Update the scrollbar width custom property on window resize.
window.addEventListener( 'resize', () => document.documentElement.style.setProperty( '--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px" ) );

window.addEventListener( 'DOMContentLoaded', () => {
  new navigation( 'site-nav');

  const siteAlertBar = document.getElementById( 'site-alert-bar' );
  if (!!siteAlertBar) {
    const siteAlertBarProps = {};

    if (!!siteAlertBar.dataset.updateInterval) {
      siteAlertBarProps.updateInterval = parseInt( siteAlertBar.dataset.updateInterval );
    }

    if (!!siteAlertBar.dataset.exclude) {
      siteAlertBarProps.exclude = JSON.parse( siteAlertBar.dataset.exclude );
    }

    if (!!siteAlertBar.dataset.risks) {
      siteAlertBarProps.defaultRisks = JSON.parse( siteAlertBar.dataset.risks );
    }

    if (!!siteAlertBar.dataset.incidents) {
      siteAlertBarProps.defaultIncidents = JSON.parse( siteAlertBar.dataset.incidents );
    }

    createApp( AlertBars, siteAlertBarProps ).mount( siteAlertBar );
  }

  const heroIncidents = document.getElementById( 'page-header-incidents' );
  if (!!heroIncidents) {
    const heroIncidentProps = {};

    if (!!heroIncidents.dataset.perPage) {
      heroIncidentProps.perPage = parseInt( heroIncidents.dataset.perPage );
    }

    if (!!heroIncidents.dataset.chipLabels) {
      heroIncidentProps.chipLabels = JSON.parse( heroIncidents.dataset.chipLabels );
    }

    if (!!heroIncidents.dataset.updateInterval) {
      heroIncidentProps.updateInterval = parseInt( heroIncidents.dataset.updateInterval );
    }

    if (!!siteAlertBar.dataset.incidents) {
      heroIncidents.defaultIncidents = JSON.parse( heroIncidents.dataset.incidents );
    }

    createApp( IncidentHeroCards, heroIncidentProps ).mount( heroIncidents );
  }

  new responsivePagination();

  document.querySelectorAll( 'dialog' )?.forEach( el => dialog( el ) );

  // Trigger the resize event on DomLoaded to set the scrollbar width.
  window.dispatchEvent(new Event('resize'));
} );

